import APIURL from "../axios";
import { useQuery } from "react-query";
const getLang = () => {
  return sessionStorage.getItem("lang");
};
const Checkout = async (uuid, lang) => {
  return await APIURL.get(`/${uuid}/order/checkout-details`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: getLang(),
    },
  });
};
export const ShowCheckout = (uuid, lang) => {
  return useQuery(`checkout`, () => Checkout(uuid, lang));
};

// Lightweight helper for applying a tip via mutation (use inside components)
export const applyTipRequest = async (uuid, tip, tipper = "guest") => {
  const response = await APIURL.post(
    `/${uuid}/orders/add-tips`,
    { tips: tip, tip_person: tipper },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        lang: getLang(),
      },
    }
  );
  return response.data;
};
